"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageFormat = void 0;
var ImageFormat = /*#__PURE__*/function (ImageFormat) {
  ImageFormat["JPEG"] = "jpeg";
  ImageFormat["PJPEG"] = "pjpeg";
  ImageFormat["WEBP"] = "webp";
  return ImageFormat;
}(ImageFormat || (exports.ImageFormat = ImageFormat = {}));

